/* eslint-disable camelcase */
import React, { PureComponent } from 'react'
import _ from 'lodash'
import { Button, Card, List } from 'semantic-ui-react'

import FeeRateForm from '../forms/feeRateForm'

class DriverSegmentRow extends PureComponent {
  state = {
    modalFeeRateVisible: false
  }

  render() {
    const { driverSegment, onView, onEdit, onRemove, drivers, onAddDriver, onAddIncentive } = this.props
    const { modalFeeRateVisible } = this.state

    return (
      <Card>
        <Card.Content>
          <Card.Header style={{ display: 'inline-block' }}>
            {driverSegment.name} ({drivers.length})
          </Card.Header>
          <Button
            floated="right"
            size="mini"
            onClick={() => this.setState({ modalFeeRateVisible: true })}
          >
            Fee Rate
          </Button>
          <Button
            size="mini"
            floated="right"
            onClick={onAddIncentive}
          >
            Incentive
          </Button>
        </Card.Content>
        <Card.Content>
          <List>
            {_.slice(drivers, 0, 4).map((driver, index) => (
              <List.Item key={driver.tel} style={{ padding: 10 }}>
                <List.Content>
                  <List.Header>{`${index + 1}. ${driver.family_name} ${driver.first_name}`}</List.Header>
                </List.Content>
              </List.Item>
            ))}
          </List>
        </Card.Content>
        <Card.Content extra style={{ textAlign: 'right' }}>
          <Button
            color="black"
            onClick={onView}
            icon="eye"
          />
          <Button
            color="blue"
            onClick={onAddDriver}
            icon="add"
          />
          <Button
            onClick={onEdit}
            icon="edit"
          />
          <Button
            color="red"
            onClick={onRemove}
            icon="trash"
          />
        </Card.Content>
        <FeeRateForm
          visible={modalFeeRateVisible}
          segmentId={driverSegment.id}
          onClose={() => this.setState({ modalFeeRateVisible: false })}
        />
      </Card>
    )
  }
}

export default DriverSegmentRow



// WEBPACK FOOTER //
// ./src/components/drivers/views/driverSegmentRow.js